(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('test-plan-monitoring', {
                parent: 'entity',
                url: '/test-plan-monitoring?status',
                data: {
                    authenticate: true,
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_SUPER_ADMIN'],
                    pageTitle: 'global.menu.tech.testPlanMonitoring'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/test-plan/test-plan-monitoring.html',
                        controller: 'TestPlanMonitoringController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('test-plan-runner', {
                parent: 'account',
                url: '/test-plan-runner?planKey',
                data: {
                    authenticate: true,
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_DATA_OPERATOR', 'ROLE_READ_ONLY', 'ROLE_SUPER_ADMIN'],
                    pageTitle: 'global.menu.account.testPlan'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/test-plan/test-plan-runner.html',
                        controller: 'TestPlanRunnerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('test-plan-create', {
                parent: 'entity',
                url: '/test-plan-create',
                data: {
                    authenticate: true,
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_SUPER_ADMIN'],
                    pageTitle: 'testPlan.create.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/test-plan/test-plan-create.html',
                        controller: 'TestPlanCreateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
